import type React from 'react';
import { useEffect } from 'react';

import { debounce, throttle } from 'lodash';

import { usePageNavigation } from 'bundles/unified-description-page-common/contexts/PageNavigationContext';

const useUpdateCtaPosition = (pageCtaRef: React.RefObject<HTMLDivElement>) => {
  const { updatePageCtaPosition } = usePageNavigation();
  useEffect(() => {
    const updateCtaPositionThrottle = throttle(() => {
      const bottom = pageCtaRef?.current?.getBoundingClientRect().bottom;
      if (bottom !== undefined) {
        updatePageCtaPosition?.(bottom);
      }
    }, 100);

    const updateCtaPositionDebounce = debounce(
      () => {
        const bottom = pageCtaRef?.current?.getBoundingClientRect().bottom;
        if (bottom !== undefined) {
          updatePageCtaPosition?.(bottom);
        }
      },
      300,
      { trailing: true }
    );

    const updateCtaPosition = () => {
      updateCtaPositionThrottle();
      updateCtaPositionDebounce();
    };

    updateCtaPosition();

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', updateCtaPosition);
      window.addEventListener('resize', updateCtaPosition);
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', updateCtaPosition);
        window.removeEventListener('resize', updateCtaPosition);
      }
    };
  }, [pageCtaRef, updatePageCtaPosition]);
};

export default useUpdateCtaPosition;
